import React from 'react'
import { Stack, Typography } from '@mui/material'

const PageHeader: React.FC = () => {
  return (
    <Stack component="div" justifyContent="center" alignItems="center" sx={{
      my: 10,
      '@media (max-width: 590px)': {
        my: 5,
        px: 2,
      },
    }}>
      <Typography sx={{
        fontSize: '60px',
        fontWeight: '700',
        fontFamily: 'MetaProBold',
        '@media (max-width: 590px)': {
          fontSize: '32px',
        },
      }}>
        CSCS Smart Check
      </Typography>
      <Typography sx={{
        fontSize: 22,
        maxWidth: '70%',
        textAlign: 'center',
        '@media (max-width: 590px)': {
          fontSize: 16,
          maxWidth: '100%',
        },
      }}>
        Verify all 2.1 million CSCS-logoed cards quickly and easily using CSCS
        Smart Check
      </Typography>
    </Stack>
  )
}

export default PageHeader
